import { useRef } from 'react'

export function useHideScrollbarWhenOtherFocused() {
    const scrollableContainerRef = useRef<HTMLDivElement>(null)
    const hideScrollbar = () => {
        if (scrollableContainerRef.current) {
            scrollableContainerRef.current.style.overflow = 'hidden'
        }
    }

    const resetScrollbar = () => {
        if (scrollableContainerRef.current) {
            scrollableContainerRef.current.style.overflow = 'auto'
        }
    }

    return { scrollableContainerRef, resetScrollbar, hideScrollbar }
}
